export function UserDashboardStats({ stats }) {
  // Dynamically set grid columns based on number of stats
  // const gridColsClass = stats.length === 5 ? 'lg:grid-cols-5' : 'lg:grid-cols-4';
  const gridColsClass = "lg:grid-cols-" + (stats.length || 3);
  
  return (
    <div className="bg-white -mx-4 sm:-mx-6 lg:-mx-8">
      <div className={`grid grid-cols-1 sm:grid-cols-2 ${gridColsClass}`}>
        {stats.map((stat, statIdx) => {
          // Border logic: add left border for odd columns on small screens, and specific columns on large screens
          let borderClass = '';
          if (statIdx % 2 === 1) {
            borderClass = 'sm:border-l';
          }
          if (stats.length === 5) {
            // For 5 stats: add borders at positions 2, 3, 4 on large screens
            if (statIdx === 2 || statIdx === 3 || statIdx === 4) {
              borderClass += ' lg:border-l';
            }
          } else {
            // For 4 stats: add border at position 2 on large screens
            if (statIdx === 2) {
              borderClass += ' lg:border-l';
            }
          }
          
          return (
            <div
              key={stat.name}
              className={`${borderClass} border-t border-gray-200 py-6 ${statIdx === 0 ? 'pl-12 pr-4 sm:pl-14 sm:pr-6 lg:pl-16 lg:pr-8' : 'px-4 sm:px-6 lg:px-8'}`}
            >
              <p className="text-sm font-medium text-gray-600">{stat.name}</p>
              <p className="mt-2 flex items-baseline gap-x-2">
                <span className="text-4xl font-semibold tracking-tight text-gray-900">{stat.value}</span>
                {stat.separator && (
                  <>
                    <span className="text-4xl font-semibold tracking-tight text-gray-400">{stat.separator}</span>
                    <span className={`text-4xl font-semibold tracking-tight ${stat.subValueColor || 'text-gray-900'}`}>
                      {stat.subValue || '–'}
                    </span>
                  </>
                )}
                {stat.unit ? <span className="text-sm text-gray-500">{stat.unit}</span> : null}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}